import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import { PdfToAudioDemoPage } from '@/components/astro/new-design-25/SEO/pdf-to-audio-demo-page';
import { pdfToAudioSearch } from '@/lib/pdf-to-audio-search';
import { hreflangLinks, seo } from '@/seo/seo';

const faqs = [
  {
    question: 'How do I turn a PDF into an audiobook?',
    answer:
      'Drop your PDF into the converter on this page. We generate natural audiobook-style narration with the AI voice of your choice, then open a 24-hour Listening link with PDF view, audio, and playback controls.',
  },
  {
    question: 'Is this the same as an audiobook from Audible?',
    answer:
      'Our AI voices are not a replacement for a professional voice actor on premium audiobooks, but for the vast majority of academic, technical, and personal long-form reading they are indistinguishable from human narration once you settle into the voice.',
  },
  {
    question: 'Can I make an audiobook from an entire book PDF?',
    answer:
      'The free preview on this page is capped at 10 pages per generation. Sign up to convert entire books, chapter-by-chapter, with consistent voice and pacing.',
  },
  {
    question: 'Will the narration sound natural for chapter-length content?',
    answer:
      'Yes. Our voices are tuned for long-form listening, not short-clip voiceover. A 45-minute chapter sounds as natural at minute 38 as at minute 2.',
  },
];

export const Route = createFileRoute('/_marketing/_seo/pdf-to-audiobook')({
  validateSearch: pdfToAudioSearch,
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title:
          'PDF to Audiobook — Turn PDFs into Long-Form Listening | Listening',
        description:
          'Turn PDF books, papers, and chapters into natural-sounding audiobooks. Drop a PDF, pick a voice, and open a 24-hour read-along link. Free, no sign-up.',
      }),
    ],
    links: [...hreflangLinks('/pdf-to-audiobook')],
  }),
  component: () => (
    <PdfToAudioDemoPage
      converterHeading='PDF to audiobook'
      converterSubtitle='Turn any PDF into a long-form audiobook with natural AI narration, PDF view, a playbar, and a 24-hour Listening link.'
      faqDescription='Quick answers about turning PDFs into audiobooks.'
      faqTitle='PDF to audiobook FAQ'
      faqs={faqs}
    />
  ),
});
